import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { NextPageService, NavigationLocation } from '@cvx/nextpage';
import { NavigationConstants } from 'src/app/constants/constants';
import { User } from '../../models/user';
import { ApplicationRole } from '../../models/ApplicationRole';

@Component({
  selector: 'app-layout',
  standalone: false,
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.less'
})
export class LayoutComponent implements OnInit {
  NavigationLocation = NavigationLocation;
  breadcrumbs: Array<{ label: string; url?: string }> = [];
  currentUser: User = new User();
  

  constructor(private NP: NextPageService, private userService: UserService) {
    this.NP.options.sitename = 'Partner Query';
  }
  ngOnInit() {    
    
    this.currentUser = this.userService.getCurrentUser();
    this.userService.userUpdated.subscribe((user: User) => {
      this.currentUser = user;      
    });
  }
  
  setMenuVisibily_Unused() {
    const existingRoutes = this.NP.options.navigationRoutes.map(route => route.path);
      if (this.currentUser.IsRFCAdmin) {
        const newRoutes = NavigationConstants.adminRoutes.filter(route => !existingRoutes.includes(route.path));
        
        //this.NP.options.navigationRoutes.push(...newRoutes);
      }
  }
  
}
